export const MAIN_MAIL = 'angelo.scialpi@ledgerthings.com';
export const INFO_MAIL = 'info@ledgerthings.com';
